<template>
  <div class="pick-up-params">
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="newServe()"
    >
      {{ $t("app.new") }}
    </el-button>
    <el-table :data="tableData" style="width: 100%" stripe>
      <el-table-column align="left" :label="$t('app.operation')">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            @click="handleDelete(scope.$index, scope.row)"
            >{{ $t("app.delete") }}</el-button
          >
          <el-button
            type="success"
            size="small"
            icon="el-icon-top"
            @click="upSort(scope.row)"
          ></el-button>
          <el-button
            type="success"
            size="small"
            icon="el-icon-bottom"
            @click="downSort(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="編碼" prop="PortCode">
      </el-table-column>
      <el-table-column align="center" label="名稱" prop="Text">
      </el-table-column>
      <el-table-column align="center" label="日期" prop="Date">
      </el-table-column>
      <el-table-column align="center" label="時間" prop="Time">
      </el-table-column>
    </el-table>
    <el-dialog
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-select
        v-model="code"
        size="small"
        :disabled="this.type != 'new'"
        style="margin-bottom: 10px; width: 100%"
        placeholder="請選擇抵步口岸"
      >
        <el-option
          v-for="item in arrivalGroup"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="date"
        size="small"
        type="date"
        value-format="yyyy年MM月dd日"
        format="yyyy年MM月dd日"
        placeholder="選擇日期"
        style="margin-bottom: 10px; width: 100%"
      >
      </el-date-picker>
      <el-time-picker
        is-range
        size="small"
        v-model="time"
        range-separator="-"
        value-format="HH:mm"
        format="HH:mm"
        start-placeholder="開始時間"
        end-placeholder="結束時間"
        placeholder="選擇時間範圍"
        style="margin-bottom: 10px; width: 100%"
      >
      </el-time-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="handleClose">{{
          $t("app.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getPickUp,
  delPickUp,
  setPickUp,
  getArrivalGroup,
  pickUpSortUp,
  pickUpSortDown,
} from "@/api/systemManagement/paramsConfig";
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      code: "",
      date: "",
      time: "",
      index: "",
      type: "",
      arrivalGroup: [],
    };
  },
  created() {
    this.getList();
    getArrivalGroup().then((res) => {
      this.arrivalGroup = res.data.map((_) => {
        return {
          value: _.CODE,
          label: _.TEXT,
        };
      });
    });
  },
  methods: {
    getList() {
      getPickUp().then(res => {
        this.tableData = res.data;
      });
    },
    handleDelete(index, obj) {
      this.$confirm("確認刪除" + obj.PortCode).then(() => {
        delPickUp(obj).then(() => {
          this.tableData.splice(index, 1);
          this.success();
        });
      });
    },
    edit(index, row) {
      this.dialogVisible = true;
      this.code = row.PortCode;
      this.date = row.Date;
      this.time = row.Time.split("-");
      this.index = index;
      this.type = "edit";
    },
    newServe() {
      this.dialogVisible = true;
      this.type = "new";
      this.code = "";
      this.date = "";
      this.time = "";
      this.index = "";
    },
    handleClose() {
      if (this.type === "new") {
        let time = this.time.join("-");
        setPickUp({
          PortCode: this.code,
          Date: this.date,
          Time: time,
        }).then(() => {
          this.success();
          this.tableData.push({
            PortCode: this.code,
            Date: this.date,
            Time: time,
          });
        });
      }
    },
    success() {
      this.$message({
        message: "操作成功",
        type: "success",
      });
      this.dialogVisible = false;
    },
    upSort(row) {
      pickUpSortUp({ Id: row.Id, Sort: row.Sort }).then((res) => {
        this.getList();
      });
    },
    downSort(row) {
      pickUpSortDown({ Id: row.Id, Sort: row.Sort }).then((res) => {
        this.getList();
      });
    },
  },
};
</script>
